import React, { createRef } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { classNames, clone } from '../../../utils';
import { BeneficiariesService, GeneralService } from '../../../services';
import { Vector2 } from '../../../assets/img';
import { AddWhite, CloseIcon } from '../../../assets/icons';
import { CreateBeneficiary } from './create-beneficiary';

class RequestBeneficiaries extends React.Component {

  state = {
    isLoading: false,
    beneficiaries: [],
    currentProducts: [],
    documentTypes: [],
    genders: [],
    phoneCodes: [],
    relationships: [],
    correlativeDni: '',
    isOnlyForOwnerProducts: false,
    selectedItem: null,
  }

  confirmModalRef = createRef();
  createModalRef = createRef();
  cartButtonRef = createRef();
  goBack = createRef();

  componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    if (!this.props.cart?.length) this.props.history.replace('/');

    this.getSelects();
    this.setState({
      isOnlyForOwnerProducts: this.props.cart.every(x => !!x.is_only_for_owner),
    });
    this.getBeneficiaries();
  }

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

  getSelects = async () => {
    Promise.all([
      GeneralService.getDocumentTypes(),
      GeneralService.getGenders(),
      GeneralService.getPhoneCodes(),
      GeneralService.getRelationships(),
    ])
      .then(res => {
        this.setState({
          documentTypes: res[0] ?? [],
          genders: res[1].map(x => ({ value: x.id, label: x.name })) ?? [],
          phoneCodes: res[2] ?? [],
          relationships: res[3].map(x => ({ value: x.id, label: x.name })) ?? [],
        });
      })
      .catch(console.log);
  }

  getBeneficiaries = async () => {
    this.setState({ isLoading: true });

    let beneficiaries = [];
    let correlativeDni = '';
    const owner = {
      id: this.props.user?.id,
      fullName: this.props.user?.fullName,
      relationship: 'Titular',
      birthdate: this.props.user?.birthdate,
    };

    try {
      const res = await BeneficiariesService.get();

      if (!this.state.isOnlyForOwnerProducts) {
        beneficiaries = res.data?.map(x => ({
          id: x.id,
          fullName: x.fullName,
          relationship: x?.relationship?.name,
          dni: x.dni,
          birthdate: x.birthdate,
        })) || [];
      }

      const correlative = beneficiaries.filter(x => String(x.dni).startsWith(this.props.user.dni + '-')).length;
      correlativeDni = `${String(this.props.user.dni).substring(1)}-${correlative + 1}`;
      beneficiaries.unshift(owner);

      // Verifica si los documentos fueron subidos (RIF o Cédula)
      const isFirstPurchase = !this.props.user.dni_file && !this.props.user.fiscal_dni_file;
      // Verifica si hay algún producto que requiera documentos adicionales
      const someProdWithDocs = this.props.cart?.some(x => !!x.required_docs?.length);

      this.props.dispatch({
        type: 'SET_REQUEST',
        payload: {
          ...this.props.request,
          // Verifica si es la primera compra para posteriormente subir los documentos
          isFirstPurchase,
          // Bandera para mostrar el modal de subir archivos en la siguiente pantalla
          isDocUploaded: !someProdWithDocs && !isFirstPurchase,
        },
      });

      this.setState({
        beneficiaries,
        correlativeDni,
        currentProducts: res.currentProducts,
      });

    } catch (error) {
      console.log(error)
    }
    this.setState({ isLoading: false });
  }

  confirmRemoveBeneficiary = async (item, index) => {
    // Verificar si el beneficiario tiene productos, en tal caso no puede ser eliminado
    const hasProducts = this.state.currentProducts.some(x => x.user_id === item.id);
    if (hasProducts) return toast.error('Este beneficiario no puede ser eliminado ya que posee productos activos');

    this.setState({ selectedItem: { item, index } });
    this.confirmModalRef.current?.showModal();
  }

  removeBeneficiary = async () => {
    if (!this.state.selectedItem) return;
    this.setState({ isLoading: true });
    const { selectedItem: { item, index } } = this.state;
    const isSelected = this.props.request?.beneficiaries?.some(x => x.id === item.id);
    if (isSelected) this.toggleBeneficiary(index);

    try {
      await BeneficiariesService.remove(item.id);
      this.getBeneficiaries();
      toast.error('Beneficiario eliminado con éxito');

    } catch (error) {
      console.log(error)
    }

    this.setState({ isLoading: false, selectedItem: null });
    this.confirmModalRef.current.close();
  }

  toggleBeneficiary = async (index) => {
    let beneficiaries = clone(this.props.request?.beneficiaries || []);
    const _beneficiaries = clone(this.state.beneficiaries);
    const benefID = _beneficiaries[index].id;
    const exists = beneficiaries.some(x => x.id === benefID);

    if (exists) {
      beneficiaries = beneficiaries.filter(x => x.id !== benefID);
    } else {
      beneficiaries = [ ...beneficiaries, { ..._beneficiaries[index] } ];
    }

    this.props.dispatch({
      type: 'SET_REQUEST',
      payload: {
        ...this.props.request,
        isDSRAnswered: false,
        currentProducts: this.state.currentProducts,
        beneficiaries,
      }
    });
  }

  toggleModal = async (reload = false) => {
    const isOpen = this.createModalRef?.current?.open;
    if (isOpen && reload) this.getBeneficiaries();
    isOpen
      ? this.createModalRef?.current?.close()
      : this.createModalRef?.current?.showModal();
  }

  submit = async () => {
    if (!this.isValidForm()) return;
    this.props.history.push('/mi-pedido');
  }

  isValidForm = (showError = true) => {
    const onError = (msg) => {
      if (showError) toast.error(msg);
      return false;
    }

    if (!this.props.request?.beneficiaries?.length)
      return onError('Debe seleccionar al menos un beneficiario');

    return true;
  }

  render() {

    const isNextStepEnabled = this.isValidForm(false);
    const { beneficiaries, correlativeDni, currentProducts, isOnlyForOwnerProducts } = this.state;
    const cartProducts = this.props.cart.map(x => x.id);

    return (
      <>
        <dialog ref={this.confirmModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
          <div className="w-[20rem] bg-white rounded-xl overflow-hidden">
            <div className="py-8 px-5">
              <p className="text-center">¿Realmente desea eliminar el beneficiario?</p>
            </div>

            <div className="flex justify-between h-12 font-semibold">
              <button
                className="flex-1 bg-white p-3"
                onClick={() => {
                  this.setState({ selectedItem: null });
                  this.confirmModalRef.current.close();
                }}
              >
                <span>Cancelar</span>
              </button>

              <button
                className="flex-1 text-red"
                onClick={this.removeBeneficiary}
              >
                <span>Aceptar</span>
              </button>
            </div>
          </div>
        </dialog>

        <dialog ref={this.createModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
          <CreateBeneficiary
            documentTypes={this.state.documentTypes}
            genders={this.state.genders}
            phoneCodes={this.state.phoneCodes}
            relationships={this.state.relationships}
            correlativeDni={correlativeDni}
            onClose={this.toggleModal}
          />
        </dialog>

        <div className="max-w-[30rem] mx-auto mt-8 lg:mt-0">
          <div>
            <div className="flex justify-center">
              <img src={Vector2} className="w-32 h-32 object-contain" alt="" />
            </div>
            <div className="mt-5 p-5 flex justify-end">
              {!isOnlyForOwnerProducts && (
                <button
                  className="flex items-center bg-blue rounded-lg p-2 text-white font-semibold gap-2"
                  onClick={() => this.toggleModal()}
                >
                  <img src={AddWhite} className="w-5 h-5 object-contain" alt="" />
                  <span>Añadir beneficiario</span>
                </button>
              )}
            </div>

            <div className="mb-5 border-t border-t-gray6">
              {beneficiaries?.map((beneficiary, index) => {
                const isSelected = this.props.request?.beneficiaries?.some(x => x.id === beneficiary.id);
                const isOwner = beneficiary.id === this.props.user?.id;
                const productsIds = currentProducts.filter(x => x.user_id === beneficiary.id).map(x => x.product_id);
                const hasProducts = this.props.cart.filter(x => productsIds.includes(x.id));
                const hasAllProducts = hasProducts?.length === cartProducts.length;
                const isDisabled = !!hasProducts.length && hasAllProducts;

                return (
                  <div
                    key={`beneficiary-${index}`}
                    className="flex items-center border-b border-b-gray6 w-full cursor-pointer"
                  >
                    <div
                      className="flex items-center py-3 px-5 text-start w-full"
                      onClick={() => isDisabled ? {} : this.toggleBeneficiary(index)}
                    >
                      <div
                        className={classNames(
                          'w-5 h-5 aspect-square rounded-md border mr-2',
                          isSelected ? 'bg-green border-green' : 'bg-gray5 border-gray6'
                        )}
                      />
                      <div className="px-2 w-full">
                        <p className="text-lg text-darkBlue font-semibold">
                          { beneficiary.fullName }
                        </p>
                        <p className="text-sm leading-3">
                          { beneficiary.relationship }
                        </p>
                        {!!hasProducts.length && (
                          <p className="text-sm text-red">
                            {this.props.cart.length > 1
                              ? (hasAllProducts
                                ? 'Los productos del carrito no están disponible para este beneficiario'
                                : 'Algunos de los productos del carrito no están disponible para este beneficiario')
                              : 'El producto no está disponible para este beneficiario'
                            }
                          </p>
                        )}
                      </div>
                    </div>
                    {!isOwner && (
                      <button className="px-2" onClick={() => this.confirmRemoveBeneficiary(beneficiary, index)}>
                        <img src={CloseIcon} className="w-4 h-4 object-contain" alt="" />
                      </button>
                    )}
                  </div>
                )
              })}
            </div>
          </div>

          <div className="flex justify-center">
            <button
              className={classNames(
                'rounded-lg text-center h-10 font-bold text-lg px-10',
                isNextStepEnabled ? 'bg-blue text-white' : 'text-gray bg-gray6'
              )}
              onClick={this.submit}
            >
              <span>Continuar</span>
            </button>
          </div>
        </div>
      </>
    )
  }
}

export default connect(state => ({
  user: state.user,
  cart: state.cart,
  request: state.request,
}))(RequestBeneficiaries);